import {connect} from "react-redux";
import CarServiceOpportunities from "./create";
import {bindActionCreators} from "redux";
import {save} from "../../../service/Opportunities/action";
import {getOpportunity} from "../../../service/CarService/action";

const mapStateToProps = (state) => ({
    dropdownValue:state.Dropdown.dropdownValue,
    saveDetails:state.Opportunitie.saveDetails,
    opportunityTypes:state.CarService.opportunityTypes,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            save,
            getOpportunity
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CarServiceOpportunities);
